import { CommonModule, NgFor, NgIf, DatePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';

import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { GalleriaModule } from 'primeng/galleria';

// import { search_filter } from '../../../_model/search_fliter';
// import { DatasearchService } from '../../_services/datasearch.service';
// import { ExportDataService } from '../../_services/export-data.service';
// import { user_privilege } from '../../../_model/user_privilege';
// import { AuthenticationService } from '../../_services/authentication.service';
// import { ConstantService } from '../../_services/constant.service';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import * as bootstrap from 'bootstrap';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { BusyService } from '../../../_services/busy.service';
import { DatasearchService } from '../../../_services/datasearch.service';
import { ExportDataService } from '../../../_services/export-data.service';
import { AuthenticationService } from '../../../_services/authentication.service';
import { ConstantService } from '../../../_services/constant.service';
import { user_privilege } from '../../../../_model/user_privilege';
import { search_filter } from '../../../../_model/search_fliter';
import { CommanService } from '../../../_services/comman.service';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { PaginatorModule } from 'primeng/paginator';

@Component({
  selector: 'app-impurities',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    CommonModule,
    GalleriaModule,
    ToastModule,
    RouterModule,
    FormsModule,
    DropdownModule,
    PaginatorModule,
  ],
  templateUrl: './impurities.component.html',
  styleUrl: './impurities.component.scss',
})
export class ImpuritiesComponent implements AfterViewInit, OnInit, OnDestroy {
  isExpanded = false;
  scrollPosition = 0;
  sortByOptions: any[] = [
    { name: 'Default', code: 'default' },
    { name: 'Router Type', code: 'order_by' },
  ];

  displayGalleria = false;
  galleriaImages: any[] = [];
  sortBy: string = 'default';
  expandedCards: boolean[] = [];
  scrollPositions: number[] = [];
  totalpages: any = 0;
  selectedPage: number = 1;
  currGBRN: any = 0;
  dataAvailablity: any[] = [];
  isAdmin: boolean = false;
  TableName: string = 'basic_product_details_MONGO';
  pageTitile = 'QuikPatent';
  isSignedIn = false;
  data: any[] = [];
  allData: any[] = [];
  currentPage_impurities: any = 1;
  currentRow_impurities: any = 15;
  current_pagenumber: number = 1;
  Default_DownloadRec_Limit: number = 500;
  maxWords: number = 40;
  maxLines: number = 5.5; // Max lines to display before truncating
  readMoreText: string = 'Read More';
  readLessText: string = 'Read Less';
  currentFilterCondition: any = [];
  noResultsFound: boolean = false;
  currentSortBy: string = '';
  application_query: string = '';
  search_filters!: search_filter;
  user_ip: string = '';
  address: string = '';
  transparent = true;

  searched = true;
  user_data: any;
  additionalOperator: string = '';
  rptDataForExcel: any = [];
  listener: (() => void) | undefined;
  cols: any[] = [];
  isVisible = false;
  columns: any[] = [];
  userid: any[] = [];
  readMore: boolean = false;
  truncatedText: string = '';
  // fullImageUrl: string | null = null;
  moaImageUrl: string | null = null;
  keggImageUrl: string | null = null;
  searchQueryGrid: string = '';
  totalRecords: number = 0;
  pagination: { totalRecords: number } = { totalRecords: 0 };
  oldRecords: number = 0;
  gbrnArray: string[] = []; // Declare gbrnArray property as an array of strings
  INCHIKEY: string = '';
  inchiKeyArray: string[] = []; // Declare userId as an array of strings
  isSidebarOpen = false;
  highlightedIndex: number | null = null;
  fullImageUrl: string = '';
  zoomLevel: number = 1;
  currentPage_technical: any = 1;
  currentRow_technical: any = 15;
  originalPlatformFilters: any = null;
  PlatformFliters: any = [];
  current_GBRN: any = 0;
  userPageLimit: any = 0;
  alertExecuted: boolean = false;
  isPanning: boolean = false;
  startX: number = 0;
  startY: number = 0;
  scrollLeft: number = 0;
  scrollTop: number = 0;
  currentFliter: any = {};
  first: any = 0;
  rows: any = 15;
  privilege_json!: user_privilege;
  is_show_Total_Search_Exceed_popup: boolean = false;
  is_show_Search_Priv_popup: boolean = false;
  is_show_Daily_Search_Exceed_popup: boolean = false;
  is_show_Download_Priv_popup: boolean = false;
  is_show_Daily_Download_Exceed_popup: boolean = false;
  is_show_Total_Download_Exceed_popup: boolean = false;
  categoryOptions: any[] = [];
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  introVideo =
    'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-Agrochemical-Pharmaceutical-Fine-Chemical-Database-Patents.mp4';
  constructor(
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    private busyService: BusyService,
    private datasearch: DatasearchService,
    private exportdataService: ExportDataService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private datePipe: DatePipe,
    private commanService: CommanService,
    private cdRef: ChangeDetectorRef
  ) {
    this.commanService.currentRow.subscribe((res) => {
      this.currentRow_technical = res;
    });
    this.commanService.currentPage.subscribe((res) => {
      this.currentPage_technical = res || 1;
    });
    this.totalpages = Math.ceil(this.totalRecords / this.rows);
    // this.commanService.getUserPrivilege().subscribe((res: any) => {
    //   this.user_data = res;
    //   this.privilege_json = res?.privilege_json || {};
    // });

    this.expandedCards = new Array(this.data.length).fill(false);
    this.scrollPositions = new Array(this.data.length).fill(0);
  }

  displayBasic: boolean = false; // To control visibility of the gallery dialog
  images: any[] = [];
  responsiveOptions = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  @HostListener('document:copy', ['$event'])
  disableCopy(event: ClipboardEvent) {
    event.preventDefault();
  }

  @HostListener('document:contextmenu', ['$event'])
  disableRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  ngOnInit(): void {
    this.listener = this.renderer.listen(
      'document',
      'keydown',
      (event: KeyboardEvent) => {
        if (
          (event.ctrlKey || event.metaKey) &&
          event.key.toLowerCase() === 'p'
        ) {
          event.preventDefault();
        }
      }
    );

    this.datasearch.dataAvailablity(this.currGBRN).subscribe(
      (res: any) => {
        this.dataAvailablity = res.data.data;
      },
      (error) => {
        console.log(error);
      }
    );
    this.commanService.currentgbrn.subscribe((gbrn_res: any) => {
      if (gbrn_res) {
        this.current_GBRN = gbrn_res;
        this.search_data();
      }
    });
    this.commanService.userPageLimit_technical.subscribe((res) => {
      this.userPageLimit = res;
    });
    this.commanService.getUserPrivilege().subscribe((res: any) => {
      this.privilege_json = res;
    });

    //   this.commanService.showPageLimitWarning_technical.subscribe((res) => {
    //   if (res) {
    //     if (!this.alertExecuted) {
    //       const maxPages = Number(this.privilege_json.PageLimit);
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Page Limit Exceeded',
    //         detail: `You can only view up to ${maxPages} page(s).`,
    //         life: 10000,
    //       });

    //       this.alertExecuted = true;

    //       setTimeout(() => {
    //         this.alertExecuted = false;
    //       }, 11000);
    //     }
    //   }
    // });
    this.commanService.productInformationData.subscribe((res: any) => {
      const rawQuery = res.searchQueryGrid || '';
      this.searchQueryGrid = this.parseSearchQuery(rawQuery); // <-- returns a string
    });
    // this.getUserPrivilege();
    this.getcolumnsimpurity();
  }
  // async getUserPrivilege(): Promise<void> {
  //   this.authentication.getCurrentUserValue().subscribe((val: any) => {
  //     console.log('[getUserPrivilege] - Current user data received:', val);

  //     this.user_data = val;

  //     // ✅ Get stored privileges from localStorage
  //     const storedPrivileges = JSON.parse(
  //       localStorage.getItem('user_privilege') || '{}'
  //     );

  //     if (!storedPrivileges || Object.keys(storedPrivileges).length === 0) {
  //       console.warn(
  //         '[getUserPrivilege] - No user_privilege found in localStorage.'
  //       );
  //       return;
  //     }

  //     // ✅ App key for agropat privilege
  //     const appKey = 'agropat-ultimate-discovery-suite-beta';
  //     const privilegeData = storedPrivileges[appKey];

  //     if (!privilegeData) {
  //       console.warn(
  //         `[getUserPrivilege] - No privilege found for app: ${appKey}`
  //       );
  //       return;
  //     }

  //     console.log(
  //       `[getUserPrivilege] - Fetched privilege data for ${appKey}:`,
  //       privilegeData
  //     );

  //     // ✅ Store locally for this component
  //     this.privilege_json = privilegeData;

  //     // ✅ Push privilege data to CommanService (Reactive access)
  //     this.commanService.currentPrivilege.next(this.privilege_json);

  //     console.log(
  //       `[getUserPrivilege] - Privilege JSON pushed to commanService for ${appKey}.`
  //     );
  //   });
  // }
  parseSearchQuery(query: string): string {
    const regex = /ACTIVE\s*INGREDIENT:\s*\(([^)]+)\)/gi;
    let matches: string[] = [];
    let match;

    while ((match = regex.exec(query)) !== null) {
      matches.push(match[1].toUpperCase()); // Convert each to uppercase
    }

    // Replace original condition logic (AND/OR/etc.) in the query
    let result = query;

    // Replace with placeholders to capture order
    let placeholderIndex = 0;
    result = result.replace(regex, () => `{{${placeholderIndex++}}}`);

    // Replace placeholders with capitalized matches
    matches.forEach((val, i) => {
      result = result.replace(`{{${i}}}`, val);
    });

    return result;
  }

  search_data(isFilterApplied = false) {
    if (isFilterApplied) {
      this.selectedPage = 1;
      this.first = 0;
      // this.commanService.currentPage_technical.next(1);
    }

    // Category filter from dropdown
    let categoryValue = this.currentFliter?.category ?? '';

    let postdata = {
      gbrn: this.current_GBRN,
      filters: {
        category: categoryValue,
      },
      // subFilters: {
      //   country:
      //     this.selectedCountry !== 'View All' ? this.selectedCountry : '',
      // },
      pagenumber: this.selectedPage,
      limit: this.rows,
    };

    this.busyService.busy();
    this.searched = false;
    this.data = [];

    this.datasearch.getplatforimpuirtydata(postdata).subscribe({
      next: (res: any) => {
        this.data = res.data.data || [];

        // Populate category dropdown
        this.categoryOptions = [
          { label: 'View All', value: '' },
          ...(res.data.category || []),
        ];

        this.totalRecords = res.data.count || 0;
        this.totalpages = Math.ceil(this.totalRecords / this.rows);

        this.busyService.idle();
      },
      error: (error: any) => {
        console.log('error', error);
        this.busyService.idle();
      },
      complete: () => {
        this.searched = true;
        this.busyService.idle();
      },
    });
  }

  applyFilter() {
    this.selectedPage = 1;
    this.first = 0;
    this.currentPage_technical = 1;

    this.commanService.currentPage_technical.next(1);
    this.cdRef.detectChanges();

    if (!this.sortBy) {
      this.resetFilter();
    } else {
      this.search_data(true);
    }
  }

  resetFilter() {
    this.currentFliter = {};
    this.selectedPage = 1;
    this.first = 0;
    this.currentPage_technical = 1;

    this.sortBy = 'default';

    this.commanService.currentPage_technical.next(1);
    this.cdRef.detectChanges();

    if (this.originalPlatformFilters) {
      this.PlatformFliters = JSON.parse(
        JSON.stringify(this.originalPlatformFilters)
      );
    } else {
      this.search_data(true);
    }
  }

  createFilter(key: string, value: any) {
    if (value === null) {
      delete this.currentFliter[key]; // Remove filter when selecting "View All"
    } else {
      this.currentFliter[key] = value; // Apply selected filter
    }
    this.search_data(true); // Refresh data based on updated filters
  }

  getPlatformFliters(item: any) {
    if (item) {
      let postdata = {
        table_name: 'TECHNICAL_ROUTE_MONGO',
        gbrn: item.toString(),
        filter: this.currentFliter,
      };

      this.busyService.busy();

      this.datasearch.getplatFormdataFilters(postdata).subscribe({
        next: (res: any) => {
          if (res.data) {
            this.PlatformFliters = res.data.data;

            // ✅ Format the `updationDate` field (extracting only "YYYY-MM-DD")
            if (this.PlatformFliters.updationDate) {
              this.PlatformFliters.updationDate = [
                { label: 'View All', value: null },
                ...this.PlatformFliters.updationDate.map((date: string) => ({
                  label: date.split('T')[0],
                  value: date.split('T')[0],
                })),
              ];
            }

            // ✅ Add "View All" option for each dropdown
            const dropdownKeys = [
              'routeType',
              'companyName',
              'typesOfRoute',
              'activeIngredient',
              'fieldOfApplication',
            ];

            dropdownKeys.forEach((key) => {
              if (this.PlatformFliters[key]) {
                this.PlatformFliters[key] = [
                  { label: 'View All', value: null },
                  ...this.PlatformFliters[key].map((item: string) => ({
                    label: item,
                    value: item,
                  })),
                ];
              }
            });

            // ✅ Add "View All" option for sorting dropdown
            // this.sortByOptions = [
            //     { name: 'View All', code: null }, // Reset sorting option
            //     { name: 'Default', code: 'default' },
            //     { name: 'Router Type', code: 'order_by' },
            // ];
          }

          this.busyService.idle();
        },
        error: (error: any) => {
          console.log('error', error);
          this.busyService.idle();
        },
        complete: () => {
          this.busyService.idle();
        },
      });
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  zoomIn(event?: Event) {
    event?.stopPropagation();
    this.zoomLevel += 0.2;
    this.applyZoom();
  }

  zoomOut(event?: Event) {
    event?.stopPropagation();
    if (this.zoomLevel > 1) {
      this.zoomLevel -= 0.2;
    } else {
      this.zoomLevel = 1;
    }
    this.applyZoom();
  }

  applyZoom(): void {
    setTimeout(() => {
      const image = document.querySelector(
        '.zoomable-image'
      ) as HTMLImageElement;
      const zoomContainer = document.querySelector(
        '.zoom-container'
      ) as HTMLElement;
      if (image && zoomContainer) {
        image.style.transform = `scale(${this.zoomLevel})`;
        image.style.transformOrigin = 'center';
        image.style.transition = 'transform 0.3s ease-in-out';

        if (this.zoomLevel > 1) {
          zoomContainer.style.overflow = 'auto';
          zoomContainer.style.cursor = 'grab';
        } else {
          zoomContainer.style.overflow = 'hidden';
          zoomContainer.style.cursor = 'default';
        }
      }
    }, 50); // Delay ensures DOM updates correctly
  }

  onMouseDown(event: MouseEvent) {
    if (this.zoomLevel <= 1) return; // No panning if not zoomed in
    const zoomContainer = document.querySelector(
      '.zoom-container'
    ) as HTMLElement;
    if (zoomContainer) {
      this.isPanning = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.scrollLeft = zoomContainer.scrollLeft;
      this.scrollTop = zoomContainer.scrollTop;
      zoomContainer.style.cursor = 'grabbing';
    }
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isPanning) return;
    event.preventDefault();
    const zoomContainer = document.querySelector(
      '.zoom-container'
    ) as HTMLElement;
    if (zoomContainer) {
      const dx = event.clientX - this.startX;
      const dy = event.clientY - this.startY;
      zoomContainer.scrollLeft = this.scrollLeft - dx;
      zoomContainer.scrollTop = this.scrollTop - dy;
    }
  }

  onMouseUp() {
    this.isPanning = false;
    const zoomContainer = document.querySelector(
      '.zoom-container'
    ) as HTMLElement;
    if (zoomContainer) {
      zoomContainer.style.cursor = this.zoomLevel > 1 ? 'grab' : 'default';
    }
  }

  /** Open Galleria */
  openGalleria(item: any) {
    this.galleriaImages = [
      {
        itemImageSrc: `https://www.chemrobotics.com/agropat/images/chemical_directory_structures/${item.chemical_structure}.png`,
      },
    ];
    this.displayGalleria = true;
    this.zoomLevel = 1;
    this.applyZoom();
  }
  ImageFullView(item: any): void {
    const ext = item.chemicalStructure.toLowerCase();
    const endsWithValidExt = ['.svg', '.jpg', '.jpeg', '.webp'].some((e) =>
      ext.endsWith(e)
    );

    this.fullImageUrl =
      'https://www.chemrobotics.com/agropat/images/chemical_directory_structures/' +
      (endsWithValidExt
        ? item.chemicalStructure
        : item.chemicalStructure + '.png');

    const modal = new bootstrap.Modal(document.getElementById('imageModal')!);
    modal.show();
  }

  /** Close Galleria When Clicking Outside */
  closeGalleria(event: MouseEvent) {
    this.displayGalleria = false;
    this.resetZoom();
  }

  /** Reset Zoom When Closing */
  resetZoom() {
    this.zoomLevel = 1;
    this.isPanning = false;

    const image = document.querySelector('.zoomable-image') as HTMLImageElement;
    const zoomContainer = document.querySelector(
      '.zoom-container'
    ) as HTMLElement;

    if (image && zoomContainer) {
      image.style.transform = 'scale(1)';
      zoomContainer.style.overflow = 'hidden';
      zoomContainer.style.cursor = 'default';
      zoomContainer.scrollLeft = 0;
      zoomContainer.scrollTop = 0;
    }
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  scrollToSection(option: string, index: number) {
    this.highlightedIndex = index;
  }

  goBack(): void {
    this.totalRecords = this.data.length; // Ensure totalRecords is updated
    this.router.navigate(['/search'], {
      state: {
        allData: this.allData,
        userid: this.userid,
        gbrnArray: this.gbrnArray,
        inchiKeyArray: this.inchiKeyArray,
        privilege_json: this.privilege_json,
        currentFilterCondition: this.currentFilterCondition,
        application_query: this.application_query,
        search_filters: this.search_filters,
        cols: this.cols,
        columns: this.columns,
        searchQueryGrid: this.searchQueryGrid,
        totalRecords: this.totalRecords,
        oldRecords: this.oldRecords,
      },
    });
  }

  ngOnDestroy(): void {
    if (this.listener) {
      this.listener();
    }
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      const spans = this.el.nativeElement.querySelectorAll('.product-info2'); // Updated selector

      spans.forEach((span: HTMLElement) => {
        const fullText = span.innerText || '';

        // Get line height and calculate maximum height allowed for the given number of lines
        const lineHeight = parseInt(
          window.getComputedStyle(span).lineHeight,
          10
        );
        const maxHeight = lineHeight * this.maxLines;

        if (span.scrollHeight > maxHeight) {
          const truncatedText = this.truncateText(span, maxHeight);

          // Create a wrapper for the text and buttons
          const wrapper = this.renderer.createElement('div');
          this.renderer.addClass(wrapper, 'product-info-wrapper'); // Updated class name
          this.renderer.setStyle(wrapper, 'display', 'inline');

          const textNode = this.renderer.createText(truncatedText);
          this.renderer.appendChild(wrapper, textNode);

          const readMoreButton = this.renderer.createElement('button');
          this.renderer.addClass(readMoreButton, 'read-more-btn2'); // Updated class name
          this.renderer.setProperty(
            readMoreButton,
            'textContent',
            this.readMoreText
          );

          const viewLessButton = this.renderer.createElement('button');
          this.renderer.addClass(viewLessButton, 'read-more-btn2');
          this.renderer.addClass(viewLessButton, 'view-less-btn2'); // Updated class name
          this.renderer.setProperty(
            viewLessButton,
            'textContent',
            this.readLessText
          );
          this.renderer.setStyle(viewLessButton, 'display', 'none');

          this.renderer.appendChild(wrapper, readMoreButton);
          this.renderer.appendChild(wrapper, viewLessButton);

          this.renderer.setProperty(span, 'innerHTML', '');
          this.renderer.appendChild(span, wrapper);

          this.renderer.listen(readMoreButton, 'click', () => {
            this.renderer.setProperty(
              span,
              'innerHTML',
              this.transformNewLines(fullText)
            );
            this.renderer.appendChild(span, readMoreButton);
            this.renderer.appendChild(span, viewLessButton);
            this.renderer.setStyle(readMoreButton, 'display', 'none');
            this.renderer.setStyle(viewLessButton, 'display', 'inline-block');
          });

          this.renderer.listen(viewLessButton, 'click', () => {
            this.renderer.setProperty(
              span,
              'innerHTML',
              this.transformNewLines(truncatedText)
            );
            this.renderer.appendChild(span, readMoreButton);
            this.renderer.appendChild(span, viewLessButton);
            this.renderer.setStyle(viewLessButton, 'display', 'none');
            this.renderer.setStyle(readMoreButton, 'display', 'inline-block');
          });
        }
      });
    }, 0);
  }

  // Method to truncate the text based on the maximum allowed height
  truncateText(p: HTMLElement, maxHeight: number): string {
    let originalText = p.innerText;
    let words = originalText.split(' ');
    let truncatedText = originalText;

    // Temporary element for text measurement
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.whiteSpace = 'pre-wrap';
    tempSpan.style.lineHeight = window.getComputedStyle(p).lineHeight;
    tempSpan.style.position = 'absolute';
    tempSpan.style.maxWidth = window.getComputedStyle(p).width;
    document.body.appendChild(tempSpan);

    while (words.length > 0) {
      truncatedText = words.join(' ') + '...';
      tempSpan.innerText = truncatedText;

      if (tempSpan.scrollHeight <= maxHeight) {
        break;
      }

      words.pop();
    }

    document.body.removeChild(tempSpan);
    return truncatedText;
  }

  onImageError(event: any) {
    // Replace the broken image with the text "inventorLogo"
    const textNode = document.createElement('span');
    textNode.style.width = '300px';

    // Replace the image with the text "inventorLogo"
    event.target.replaceWith(textNode);
  }
  // @HostListener('window:resize', ['$event'])
  // onResize(event: any) {
  //   if (window.innerWidth > 768) {
  //     // Automatically open the sidebar for large screens
  //     this.isSidebarOpen = true;
  //   } else {
  //     // Close the sidebar for smaller screens
  //     this.isSidebarOpen = false;
  //   }
  // }

  getFirstPart(synonyms: string): string[] {
    // Ensure it's split into an array and get the first 10 items
    return synonyms?.split(',').slice(0, 10) || [];
  }

  getSecondPart(synonyms: string): string[] {
    // Ensure it's split into an array and get items from 11 to 20
    return synonyms?.split(',').slice(10, 20) || [];
  }
  // Utility function to handle new lines in text
  transformNewLines(text: string) {
    return text ? text.replace(/\n/g, '<br>') : '';
  }
  openLink(link: string): void {
    const url = `https://worldwide.espacenet.com/patent/search/family/${link}/publication/${link}A1?q=${link}`;
    window.open(url, '_blank');
  }

  keggFullView(item: any): void {
    this.keggImageUrl = `https://www.chemrobotics.com/agropat/images/ghs_pictograms/${item.keggImage}`;
    const modal = new bootstrap.Modal(document.getElementById('keggModal')!);
    modal.show();
  }

  MoaFullView(item: any): void {
    this.moaImageUrl = `https://www.chemrobotics.com/agropat/images/ghs_pictograms/${item.moaImage}`;
    const modal = new bootstrap.Modal(document.getElementById('moaModal')!);
    modal.show();
  }

  exportToPDF() {
    window.print();
  }

  showToast() {
    this.messageService.add({
      severity: 'info ',
      summary: 'Coming Soon',
      detail: 'This feature is coming soon!',
    });
  }

  copyToClipboardFormattedDate(value: any): void {
    const formattedDate = this.datePipe.transform(value, 'yyyy-MM-dd'); // Format the date
    if (formattedDate) {
      this.copyToClipboard(formattedDate); // Call your existing copy function
    }
  }
  copyToClipboard(value: string): void {
    // Use the Clipboard API to copy the text
    navigator.clipboard
      .writeText(value)
      .then(() => {
        // Show the success toast notification using PrimeNG's MessageService
        this.messageService.add({
          severity: 'success',
          summary: 'Copied to Clipboard',
          detail: value,
        });
      })
      .catch((err) => {
        // Log error to the console
        console.error('Failed to copy text:', err);

        // Show an error notification if clipboard operation fails
        this.messageService.add({
          severity: 'error',
          summary: 'Failed to Copy',
          detail: 'There was an error copying the text.',
        });
      });
  }

  checkUserDownloadPrivillege(): boolean {
    console.log('Checking download privileges');
    //Check User Have Access to Search
    if (!this.privilege_json.Download) {
      console.log('User does not have download access');
      this.is_show_Download_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to download data from this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todayDownloadCount =
      Number(this.privilege_json.today_download_count) || 0;
    const dailyDownloadLimit =
      Number(this.privilege_json.DailyDownloadLimit) || 0;
    if (todayDownloadCount >= dailyDownloadLimit) {
      this.is_show_Daily_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily download limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const downloadCount = Number(this.privilege_json.DownloadCount) || 0;
    if (downloadCount <= 0) {
      this.is_show_Total_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available download limit.',
      });
      return false;
    }
    this.privilege_json.DownloadCount = downloadCount - 1;
    this.privilege_json.today_download_count = todayDownloadCount + 1;

    // Save updated counts to localStorage
    const today = new Date().toDateString();
    const userData = {
      date: today,
      today_search_count: this.privilege_json.today_search_count,
      today_download_count: this.privilege_json.today_download_count,
    };
    localStorage.setItem(
      `user_${this.user_data.userid}_daily_counts`,
      JSON.stringify(userData)
    );

    // console.log(`Updated download counts: total=${this.privilege_json.DownloadCount}, today=${this.privilege_json.today_download_count}`);

    return true;
  }

  navigateToUrl(link: string) {
    // Define the base URL for the patent link
    const baseUrl = 'https://patents.google.com/patent/';

    // Construct the full URL by appending the link to the base URL
    const finalUrl = baseUrl + link.trim();

    // Log the constructed URL for debugging purposes
    console.log('Navigating to:', finalUrl);

    // Open the link in a new tab
    window.open(finalUrl, '_blank');
  }
  goBackToSearch() {
    // this.DynamicSearchComponent.filterForm_dynamic.reset();
    // Navigate back to the search page or route

    this.commanService.isTableSimple.next(false);
    this.commanService.isTableDynamic.next(false);
    this.commanService.isTableAdvance.next(false);
    this.commanService.currentPage.next(1);
    this.commanService.currentRow.next(15);
    this.commanService.currentData.next({});
    this.commanService.currentPrivilege.next({});
    this.router.navigate(['/']).then(() => {
      window.scrollTo(0, 0);
    });
  }
  navigateToWebsite(buttonType: string, productIndex: number): void {
    const accessKey = 'MTA5Ng%3D%3D';
    // Check if 'gbrnArray' and 'inchiKeyArray' exist and the specific product index is valid
    if (
      this.gbrnArray &&
      this.gbrnArray[productIndex] &&
      this.inchiKeyArray &&
      this.inchiKeyArray[productIndex]
    ) {
      // Get the gbrn and INCHIKEY values for the specific product
      const gbrn = this.gbrnArray[productIndex];
      const inchiKey = this.inchiKeyArray[productIndex];
      let url = '';

      switch (buttonType) {
        case 'gasp':
          url = `https://www.chemrobotics.com/pesticides-directory/index_gbrn1.php?access_key=${accessKey}&gb_reg_no=${gbrn}`;
          break;
        case 'ibd':
          url = `https://www.chemrobotics.com/agropat-ultimate/ipd-list.php?access_key=${accessKey}&gb_reg_no=${gbrn}`;
          break;
        case 'mrl':
          url = `https://www.chemrobotics.com/agropat-ultimate/mrl-list.php?access_key=${accessKey}&gb_reg_no=${gbrn}`;
          break;
        case 'wipo':
          // Use the INCHIKEY for the 'wipo' URL
          url = `https://patentscope.wipo.int/search/en/result.jsf?access_key=${accessKey}&inchikey=${inchiKey}`;
          break;
        default:
          alert('Invalid Button Type');
          return;
      }
      window.open(url, '_blank'); // Open the URL in a new tab
    } else {
      alert('GBRN or INCHIKEY is missing or invalid!');
    }
  }
  toggleCard(index: number) {
    if (!this.expandedCards[index]) {
      // Store the scroll position when expanding
      this.scrollPositions[index] =
        window.scrollY || document.documentElement.scrollTop;
    } else {
      // Scroll back to the saved position when collapsing
      setTimeout(() => {
        window.scrollTo({
          top: this.scrollPositions[index],
          behavior: 'smooth',
        });
      }, 100);
    }

    this.expandedCards[index] = !this.expandedCards[index];
  }

  // In your component
  private hasShownPageLimitWarning = false;

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.selectedPage = event.page + 1;

    this.currentPage_impurities = this.selectedPage;
    this.currentRow_impurities = this.rows;

    this.commanService.currentPage_technical.next(this.selectedPage);
    this.commanService.currentRow_technical.next(this.rows);

    // Check page limit only if warning hasn't been shown yet
    if (+this.selectedPage > +this.privilege_json.PageLimit) {
      if (!this.hasShownPageLimitWarning) {
        this.hasShownPageLimitWarning = true; // ✅ Prevent future alerts
        const maxPages = Number(this.privilege_json.PageLimit);
        this.messageService.add({
          severity: 'error',
          summary: 'Page Limit Exceeded',
          detail: `You can only view up to ${maxPages} page(s).`,
          life: 600,
        });
      }
      return;
    }
    this.hasShownPageLimitWarning = false;

    this.search_data();
    window.scrollTo(0, 0);
  }
  hasExpandableContent(item: any): boolean {
    return !!(item.description || item.packSize);
  }
  getCleanPdfUrl(rawUrl: string): string {
    // If the URL starts with 'chrome-extension://', extract the part after it
    const httpsIndex = rawUrl.indexOf('https://');
    if (httpsIndex !== -1) {
      return rawUrl.slice(httpsIndex);
    }
    return rawUrl;
  }

  displayMap: { [key: string]: boolean } = {};

  getcolumnsimpurity() {
    this.datasearch.getcolumnsimpurity().subscribe(
      (res) => {
        // console.log('Dropdown response:', res);

        this.columns = res.data; // Use the array from 'data'

        this.displayMap = {};
        res.data.forEach((col: any) => {
          this.displayMap[col.tableColumnName] = Number(col.isDisplay) === 1;
        });

        // console.log('Display Map:', this.displayMap);
      },
      (error) => {
        console.error('Error fetching dropdown data', error);
      }
    );
  }

  exportExcel(extension: any) {
    // console.log('📥 Export initiated with extension:', extension);

    this.busyService.busy();

    // Use filter from currentFliter same as search_data
    let categoryValue = this.currentFliter?.category ?? '';
    let postdata = {
      table_name: 'impurity_mongos',
      gbrn: this.current_GBRN,
      filters: {
        category: categoryValue,
      },
      pagenumber: this.selectedPage,
      limit: 500,
    };

    // console.log('📤 Sending post data for export:', postdata);

    this.datasearch.getplatforimpuirtydata(postdata).subscribe({
      next: (response: any) => {
        // console.log('✅ Data received for export:', response);

        let DownloadData = response.data || [];
        // console.log('📦 Raw download data:', DownloadData);

        this.rptDataForExcel = [];

        // Use columns fetched from your component
        let cols = this.columns || []; // make sure 'columns' is set correctly before this call
        // console.log('📋 All columns from component:', cols);

        // Filter displayed columns sorted by display order
        const displayedColumns = cols
          .filter((col) => Number(col.isDisplay) === 1)
          .sort((a, b) => a.displayOrder - b.displayOrder);

        // Get fields and headers
        const fields = displayedColumns.map((col) => col.tableColumnName);
        const headers = displayedColumns.map(
          (col) =>
            col.displayColumnName || col.excelColumnName || col.tableColumnName
        );

        // Step 1: Filter columns that actually have data
        const nonEmptyFields = fields.filter((field) => {
          return DownloadData.some((row: any) => {
            // <-- typed here
            if (row.gbrn_products?.length > 0) {
              return row.gbrn_products.some(
                (prod: any) =>
                  prod[field] !== null &&
                  prod[field] !== undefined &&
                  prod[field] !== ''
              );
            }
            return (
              row[field] !== null &&
              row[field] !== undefined &&
              row[field] !== ''
            );
          });
        });

        // Map headers for non-empty fields only
        const filteredHeaders = displayedColumns
          .filter((col) => nonEmptyFields.includes(col.tableColumnName))
          .map(
            (col) =>
              col.displayColumnName ||
              col.excelColumnName ||
              col.tableColumnName
          );

        // Step 2: Filter rows that have data in at least one of the non-empty columns

        const filteredDataRows = DownloadData.filter((row: any) => {
          // <-- typed here
          return nonEmptyFields.some((field) => {
            if (row.gbrn_products?.length > 0) {
              return row.gbrn_products.some(
                (prod: any) =>
                  prod[field] !== null &&
                  prod[field] !== undefined &&
                  prod[field] !== ''
              );
            }
            return (
              row[field] !== null &&
              row[field] !== undefined &&
              row[field] !== ''
            );
          });
        });

        // Step 3: Build the final export data array for rows and fields filtered
        filteredDataRows.forEach((row: any, index: number) => {
          row.S_NO = index + 1;
          const rowData = nonEmptyFields.map((field) => {
            if (row.gbrn_products?.length > 0) {
              const gbrnProduct = row.gbrn_products[0];
              if (gbrnProduct.hasOwnProperty(field)) {
                return gbrnProduct[field];
              }
            }
            return row[field];
          });
          this.rptDataForExcel.push(rowData);
        });

        // console.log('✅ Displayed Headers:', filteredHeaders);
        // console.log('📊 Final export data:', this.rptDataForExcel);

        let reportData = {
          title: 'Impuirty Data Report',
          data: this.rptDataForExcel,
          headers: filteredHeaders,
          sheetname: 'data',
          file_extention: extension,
          searchterm: this.searchQueryGrid,
        };

        // console.log('📁 Preparing to export with reportData:', reportData);

        this.exportdataService.exportExcel(reportData);
      },

      error: (error: any) => {
        console.error('❌ Error during data fetch for export:', error);
        this.busyService.idle();
      },
      complete: () => {
        // console.log('✅ Export process completed.');
        this.busyService.idle();
      },
    });
  }
}
